import axios from 'axios';
import store from './redux/app/Store';

const VENDOR_PIM_URL = process.env.REACT_APP_API_PIM_URL;
const FALLBACK_URL = 'https://bilgimerkezi.idefix.com/';

export interface EnotcaSSOResponse {
  success: boolean;
  message: string;
  loginUrl: string;
}

export const getEnotcaSSOUrl = async (): Promise<string> => {
  try {
    const vendorId = store.getState().auth?.user?.vendor?.id;

    const response = await axios.post<EnotcaSSOResponse>(
      `${VENDOR_PIM_URL}/sso/enocta/${vendorId}`
    );

    if (response.data.success && response.data.loginUrl) {
      return response.data.loginUrl;
    } else {
      console.error('Enocta SSO error:', response.data.message || 'SSO URL alınamadı');
      return FALLBACK_URL;
    }
  } catch (err: any) {
    console.error('Enocta SSO error:', err);
    return FALLBACK_URL;
  }
};
